<template>
  <el-dialog
    style="z-index: 9!important;"
    top="5vh"
    z-index="90"
    :modal-append-to-body="false"
    :append-to-body="true"
    :title="`${this.form.id ? '修改' : '新建'}指引`"
    :visible="visible"
    :show-close="false"
  >
    <el-form ref="form" :model="form" label-width="120px" :rules="rules">
      <el-form-item label="所属基地" required>
        {{ baseInfo.com_name }}
      </el-form-item>
      <el-form-item label="指引名称" prop="name">
        <el-input
          v-model="form.name"
          class="w-96"
          placeholder="请输入指引名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="指引类型" prop="type">
        <el-radio-group v-model="form.type">
          <el-radio :label="1">取样指引</el-radio>
          <el-radio :label="2">卸货指引</el-radio>
          <el-radio :label="3">提货指引</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="移动端顶部标签" prop="top_label">
        <el-input
          v-model="form.top_label"
          class="w-96"
          placeholder="请输入移动端顶部标签"
        ></el-input>
      </el-form-item>
      <el-form-item label="车辆业务类型" prop="car_business_ids">
        <tableSelector
          v-model="form.car_business_ids"
          :rows.sync="form.car_business_list"
          url="/api/queue/admin/query_business"
          :params="{
            is_parent: 1,
            state: 1,
            keyword: ''
          }"
          :columns="[
            { label: '车辆代码', prop: 'code' },
            { label: '车辆预约业务类型', prop: 'name' }
          ]"
        >
          <template slot="content">
            <div>
              <div
                class="text-gray-500"
                v-for="item in form.car_business_list"
                :key="item.id"
              >
                {{ item.name }}
              </div>
            </div>
          </template>
          <el-link type="primary" :underline="false">选择</el-link>
        </tableSelector>
      </el-form-item>
      <el-form-item label="正文" prop="content">
        <div class="form-right-max">
          <script
            id="guide_editor"
            type="text/plain"
            style="width: 100%;line-height: normal;min-height: 300px;"
          ></script>
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer space-x-2">
      <el-button size="small" @click="onCancel">取 消</el-button>
      <el-popconfirm title="确认保存指引吗？" @confirm="onSave">
        <el-button slot="reference" size="small" type="primary">确 定</el-button>
      </el-popconfirm>
    </span>
  </el-dialog>
</template>

<script>
import tableSelector from "@/components/tableSelector/index.vue";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      visible: false,
      guide_editor: null,
      form: {
        car_business_ids: [],
        car_business_list: []
      },
      rules: {
        name: [{ required: true, message: "请输入指引名称", trigger: "blur" }],
        type: [
          { required: true, message: "请选择指引类型", trigger: "change" }
        ],
        top_label: [
          { required: true, message: "请输入移动端顶部标签", trigger: "change" }
        ],
        content: [{ required: true, message: "请输入正文", trigger: "change" }]
      }
    };
  },
  computed: {
    ...mapGetters(["baseInfo"])
  },
  components: {
    // 关键步骤：注册 tableSelector，确保“选择”按钮点击后能真正触发弹窗打开逻辑。
    tableSelector
  },
  methods: {
    async onOpen(row) {
      const defaultForm = {
        type: 1,
        car_business_ids: [],
        car_business_list: []
      };
      if (row && row.id) {
        const dataObj = await this.$common.http({
          url: "/api/queue/admin/detail_guide",
          data: {
            id: row.id
          }
        });
        this.form = {
          ...defaultForm,
          ...(dataObj.data.data || {})
        };
      } else {
        this.form = defaultForm;
      }
      this.visible = true;
      this.$nextTick(() => {
        const editor = this.init_ued();
        if (editor) {
          editor.ready(() => {
            editor.setContent(this.form.content || "");
          });
        }
      });
    },
    onCancel() {
      this.form = {
        car_business_ids: [],
        car_business_list: []
      };
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
        this.visible = false;
      });
    },
    // 富文本编辑器初始化
    init_ued() {
      let toolbars = [
        "paragraph",
        "fontsize",
        "bold",
        "italic",
        "underline",
        "strikethrough",
        "unlink",
        "|",
        "forecolor",
        "backcolor",
        "background",
        "|",
        "indent",
        "justifyleft",
        "justifycenter",
        "justifyright",
        "justifyjustify",
        "|",
        "insertorderedlist",
        "insertunorderedlist",
        "|",
        "insertimage",
        "inserttable",
        "preview",
        "insertvideo",
        "source"
      ];
      this.guide_editor = window["UE"].getEditor("guide_editor", {
        toolbars: [toolbars],
        autoFloatEnabled: false // 是否保持toolbar位置不动
      });
      return this.guide_editor;
    },
    onSave() {
      const content = this.guide_editor.getContent();
      this.$set(this.form, "content", content.trim());
      const url = !this.form.id
        ? "/api/queue/admin/create_guide"
        : "/api/queue/admin/update_guide";
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return;
        }
        this.$common
          .http({
            url,
            data: {
              ...this.form,
              state: "1",
              bottom_version: ""
            }
          })
          .then(() => {
            this.$message.success("操作成功");
            this.$emit("ok");
            this.onCancel();
          });
      });
    }
  },
  beforeDestroy() {
    window["UE"].delEditor("guide_editor");
  }
};
</script>

<style lang="less" scoped></style>
